<template>
  <div class="page-loader" :class="{hide:loader == false}">
    <div class="page-loader--inner">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      <span>{{$t('loader')}}</span>
    </div>
  </div>
  <div class="prijscalc__intro">{{$t('intro')}}</div>
  <form id="prijscalc__form" method="post" @submit.prevent="submitForm" novalidate autocomplete="off">
   <first-fieldset
   @values-first="getValuesSpecifications"
   @weight-validity="getWeightValidity"
   @picker-status="getPickerStatus"
   :validationFirst="this.validationFirst"
   :weightInputCheck="this.weightInputStatus"
   />
    <second-fieldset
    @values-second="getSectors"
    @weight-check="checkWeightInput"
    :validationSecond="this.validationSecond"
    :weightFromFirst="this.weight"
    :weekFromFirst="this.week"
    :yearFromFirst="this.year"
    :weightValidity="this.weightValidity"
    :inputCheckEmptyFirst="this.inputCheckEmpty"
    :validationFirst="this.weightValidity"
    :pickerStatus="this.pickerStatus"
    />
    <third-fieldset
    @values-third="getCustomerData"
    :validationThird="this.validationThird"
    />
    <div class="form__item folder__form--submit">
      <button>{{$t('form.labelSubmitButton')}}<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path id="Icon_material-arrow-forward" data-name="Icon material-arrow-forward" d="M14,6,12.59,7.41,18.17,13H6v2H18.17l-5.58,5.59L14,22l8-8Z" transform="translate(-6 -6)" fill="#fff"/>
      </svg>
      </button>
   </div>
  </form>
</template>

<script>
import axios from 'axios';
export default {

  data(){
    return{
      resultsFirst: '',
      resultsThird: '',
      statusFirst: '',
      statusThird: '',
      validationFirst: '',
      validationSecond: '',
      validationThird: '',
      weightValidity: '',
      weightInputStatus: '',
      pickerStatus: false,
      data: {},
      weight: 0,
      week: 0,
      year:0,
      inputCheckEmpty: true,
      loader: false
    };
  },
  mounted: function() {
    this.setInitialDate();
  },
  methods:{
    scrollToElement(id){
      var element = document.querySelector(id);
      const yOffset = -132;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    },
    setInitialDate(){
      var date = new Date();
      var startDate = new Date(date.getFullYear(), 0, 1);
      var days = Math.floor((date - startDate) /(24 * 60 * 60 * 1000));
      var weekNumber = Math.ceil(days / 7);
      var acutualYear = date.getFullYear();
      this.year = acutualYear;
      this.week = weekNumber;
    },

    checkWeightInput(weightInputStatus){
      this.weightInputStatus = weightInputStatus;
    },

    // function that gets triggerd when
    // FROM FIRST
    getValuesSpecifications(array){
      this.resultsFirst = array;
      if(this.resultsFirst != null){
        this.weight = this.resultsFirst.Weight;
        this.week = this.resultsFirst.Week;
        this.year = this.resultsFirst.Year;
      }
    },

    getWeightValidity(value){
      this.weightValidity = value;
    },

    getPickerStatus(value){
      this.pickerStatus = value;
      console.log("de pickerstatus in app.vue is "+value);
    },

    //FROM SECOND
    getSectors(array){
      this.resultSecond = array;
    },
    //FROM THIRD
    getCustomerData(array){
      this.resultsThird = array;
    },

    submitForm(e){
      e.preventDefault();
      //CHECKS ON FIRST AND THIRD PART
      var lang = document.documentElement.lang;
      var host = 'https://'+window.location.host+'/';
      if(this.resultsFirst.validationFirst == "go" && this.resultsThird.status == "go" && this.resultSecond.sectors.length > 0){
        //console.log(this.resultsFirst);
        //console.log(this.resultsThird);

       let data = {
          distributionYear: this.resultsFirst.Year,
          distributionWeek: this.resultsFirst.Week,
          remark: this.resultsThird.remark,
          orderName: this.resultsThird.onderwerp,
          folder: {
            name: '',
            language: 'NL',
            weight: this.resultsFirst.Weight,
            //pageSize: this.resultsFirst.pageSize,
            pageSize: 10,
            sectors: this.resultSecond.sectors,
          },
          customer: {
            companyName: this.resultsThird.companyName,
            VAT: this.resultsThird.vatNr.replace(/\s/g,''),
            email: this.resultsThird.email,
            phone: this.resultsThird.phoneNr,
            firstName: this.resultsThird.firstName,
            lastName: this.resultsThird.lastName,
            companyType: this.resultsThird.companyType,
            reference: this.resultsThird.customerRef,
            language: this.resultsThird.language
          },
          address: {
            street: this.resultsThird.street,
            houseNumber: this.resultsThird.streetNumber,
            box: this.resultsThird.boxNr,
            zipcode: this.resultsThird.zipCode,
            city: this.resultsThird.city,
            countrycode: this.resultsThird.country
          }
        }
        this.validationFirst = "go";
        this.validationSecond = "go";
        this.validationThird = "go";
        this.loader = true;
        //https://salesorderservice-uat.eu.cloudhub.io
        //Username: 5fa0e7cd1ed24564abc387e679ae92ba
        //Password: bcD2c9B09ca34a49B2D8CFc9021f38a4
        //https://salesorderservice-prd.eu.cloudhub.io
        //username:'224db48d4c9c49e38d739a44c152d610',
        //password: '9821Fd405e1b41acb28FE4587270Bb4b'
        //UAT
        axios.post('https://salesorderservice-uat.eu.cloudhub.io/api/4.0/quotations',data,{
            auth: {
              username:'5fa0e7cd1ed24564abc387e679ae92ba',
              password: 'bcD2c9B09ca34a49B2D8CFc9021f38a4'
            }
          }

        // LIVE
        /*axios.post('https://salesorderservice-prd.eu.cloudhub.io/api/4.0/quotations',data,{
            auth: {
              username:'224db48d4c9c49e38d739a44c152d610',
              password: '9821Fd405e1b41acb28FE4587270Bb4b'
            }
          }*/
        )
        .then(response => {
           let status = response.status;
           if(status == 200){
                //redirect to page
            let quotationId = response.data.quotationId;
            if(lang == 'nl'){
                window.location.href = "https://bdmedia.be/nl/bedankt";
              }else{
                window.location.href = "https://bdmedia.be/fr/merci";
              }
                // send mail
              axios.get(host+'send-mail?lang='+lang+'&email='+this.resultsThird.email+'&qId='+quotationId)
                .catch((error) =>{
                  console.log(error);
                })
           }
           //console.log(length);
        })
        .catch((error) =>{
           // handle error
          console.log(error);
          // send mail to USER
          axios.get(host+'send-mail-error-user?lang='+lang+'&email='+this.resultsThird.email)
           .then(function(){
                  if(lang == 'nl'){
                      window.location.href = "https://bdmedia.be/nl/bedankt";
                  }else{
                      window.location.href = "https://bdmedia.be/fr/merci";
                  }
                })
            .catch((error) =>{
              console.log(error);
          });

          // send mail to BD MEDIA
          axios.get(host+'send-mail-error?data='+JSON.stringify(data)+'&lang='+lang)
           .then(function(){
                  if(lang == 'nl'){
                      window.location.href = "https://bdmedia.be/nl/bedankt";
                  }else{
                      window.location.href = "https://bdmedia.be/fr/merci";
                  }
                })
            .catch((error) =>{
              console.log(error);
          })
        })
      }else{
        if(this.resultsFirst.validationFirst != 'go'){
          this.validationFirst = "hold";
          this.scrollToElement("#prijscalc_gewicht-wrapper");
        }
        if(this.resultsThird.status != 'go'){
           this.validationThird = "hold";
           this.scrollToElement("#fieldset__third--wrapper");
        }
        if(this.resultSecond.sectors.length == 0){
          this.inputCheckEmpty = false;
          this.validationSecond = "hold";
          this.scrollToElement("#fieldset__second--dynamic");
        }
      }
      //this.data = Object.assign(this.resultFirst,this.resultThird);
    }
  }
};
</script>
